<template>

<div>
<v-layout my-3>
  <v-flex xs12 sm6 offset-sm3>
    <v-card>
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-3">Acerca De...</h3>
          <div>
            <p>MECVision es una aplicación web progresiva (PWA) que utiliza la visión por computadora (detección de objetos) para estimar la cantidad de huevos de mosquito en papel ovitraprap.</p>
            <p>Consulte la <a href="https://github.com/abtassociates/mecvision">página del proyecto</a> si desea contribuir al proyecto MECVision o adaptarlo para sus propios fines.</p>
            <p>Este proyecto MECVision fue desarrollado por <a href="https://www.abtassociates.com">Abt Associates</a> con el apoyo del <a href="https://www.usaid.gov/documents/1862/zika-airs-project-zap">Proyecto Zika AIRS (ZAP)</a> de la <a href="https://www.usaid.gov">Agencia de los Estados Unidos para el Desarrollo Internacional (USAID)</a>.</p>
          </div>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</v-layout>

</div>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>
